export function canFetchAnalysis(
	open: boolean,
	loading: boolean,
	areFiltersValid: boolean,
	canDispatch: boolean
) {
	return open && !loading && areFiltersValid && canDispatch;
}
